import React from 'react';
import PropTypes from 'prop-types';
import {
  HtmlView as BaseSKMathJax,
  HTML_VIEW_VARIANTS,
} from '@skooldio/skooldio-classroom-components';
import styled from 'styled-components';

import { useConfig } from 'Context/ConfigContext';
import { SvgIcon } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

import KatexPreview from './Katex';

const customLoading = () => <SvgIcon color={'primary'} icon={SvgIcon.ICON_LIST.LOADING} />;

const SKMathJax = styled((props) => <BaseSKMathJax {...props} />)`
  white-space: normal !important;

  & img {
    max-width: 100%;
    display: block;
  }

  /* NOTE: Fixed MathJax overflow issues on mobile devices (width ≤ 768px) 
  - https://skooldio.atlassian.net/browse/ANY-1674
  - https://skooldio.atlassian.net/browse/ANY-1681
  */
  @media (max-width: ${getTheme('breakpoints.1')}) {
    & p {
      overflow-x: auto;
      padding: 8px 0px 16px 0px;
    }
  }
`;

const HTMLView = ({ rawContent, ...restProps }) => {
  const { classroom } = useConfig();
  const latexTranspiler = classroom?.article?.latexTranspiler ?? 'MATHJAX';
  if (latexTranspiler === 'KATEX') {
    return <KatexPreview rawContent={rawContent} {...restProps} />;
  }
  return (
    <SKMathJax
      variant={HTML_VIEW_VARIANTS.WITH_LOADING_MATHJAX}
      loadingComponent={customLoading}
      {...restProps}
    >
      {rawContent}
    </SKMathJax>
  );
};

HTMLView.propTypes = {
  rawContent: PropTypes.string.isRequired,
  className: PropTypes.string,
};

HTMLView.defaultProps = {
  rawContent: '',
};

export default HTMLView;
